import { createSlice } from "@reduxjs/toolkit";

const classdetailSlice = createSlice({
  name: "classDetail",
  initialState: {
    data: {},
    bgcolor: ''
  },
  reducers: {
    setClassData: (state, action) => {
      state.data = action.payload;
    },
    setBgcolor: (state, action) => {
      state.bgcolor = action.payload;
    }
  },
});

export const { setClassData, setBgcolor } = classdetailSlice.actions;

export default classdetailSlice.reducer;
